import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { TYPE_CHANGE_PLAN } from '@/constants';

@Component({
  methods: {},
  computed: {
    TYPE_CHANGE_PLAN() {
      return TYPE_CHANGE_PLAN;
    },
    mapTypeChangePlanAndMessage1(): Record<string, string> {
      return {
        UPGRADE: this.$t('payment.fail.upgradeMessage1'),
        DOWNGRADE: this.$t('payment.success.downgradeMessage1'),
        CANCEL: this.$t('payment.fail.cancelMessage1'),
        USE_SAME: this.$t('payment.fail.useSameMessage1'),
        CHANGE_ALREADY_SCHEDULE: this.$t('payment.fail.changeAlreadyScheduleMessage1'),
      };
    },
    mapTypeChangePlanAndMessage2(): Record<string, string> {
      return {
        UPGRADE: this.$t('payment.fail.upgradeMessage2'),
        DOWNGRADE: this.$t('payment.success.downgradeMessage2'),
        CANCEL: this.$t('payment.fail.cancelMessage2'),
        USE_SAME: this.$t('payment.fail.useSameMessage2'),
        CHANGE_ALREADY_SCHEDULE: this.$t('payment.fail.changeAlreadyScheduleMessage2'),
      };
    },
    mapErrorCodeAndMsg(): Record<string, string> {
      return {
        '90000': this.$t('payment.fail.code.90000'),
        '90001': this.$t('payment.fail.code.90001'),
        '90002': this.$t('payment.fail.code.90002'),
        '90003': this.$t('payment.fail.code.90003'),
        '90004': this.$t('payment.fail.code.90004'),
        '90005': this.$t('payment.fail.code.90005'),
        '90006': this.$t('payment.fail.code.90006'),

        '00001': this.$t('payment.fail.code.00001'),
        '00002': this.$t('payment.fail.code.00002'),
        '00003': this.$t('payment.fail.code.00003'),
        '00004': this.$t('payment.fail.code.00004'),

        '00101': this.$t('payment.fail.code.00101'),
        '00201': this.$t('payment.fail.code.00201'),
        '00202': this.$t('payment.fail.code.00202'),
        '00203': this.$t('payment.fail.code.00203'),
        '00204': this.$t('payment.fail.code.00204'),
        '00205': this.$t('payment.fail.code.00205'),

        '00301': this.$t('payment.fail.code.00301'),
        '00302': this.$t('payment.fail.code.00302'),
      };
    },
  },
})
export default class PlanChangeFail extends Vue {
  @Prop(Boolean) readonly openPlanChangeFail;
  @Prop(String) readonly typeChangePlan;
  @Prop(String) readonly errorCode;

  @Emit('close') close() {}
}
